import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockLinkCardProps } from '@ts-blocks/block-link-card/interfaces'
import type { BrandShapeIconColor, BrandShapeIconShape } from '@UI/Brand/BrandShapeIcon'
// hooks
import { useEventsSection } from '@hooks/events/sections/events-section.hook'

const DISCIPLINE_PLATES: Record<BlockLinkCardProps['discipline'], { shape: BrandShapeIconShape, color: BrandShapeIconColor }> = {
  math: { shape: 'hexagon', color: 'ultraviolet' },
  ela: { shape: 'speech-bubble', color: 'sky' },
}

interface BlockLinkCardHookOptions {
  block: () => BlockLinkCardProps
}

interface BlockLinkCardHookReturn {
  refHref: ComputedRef<string>
  refPlateShape: ComputedRef<BrandShapeIconShape>
  refPlateColor: ComputedRef<BrandShapeIconColor>
  handleClick: () => void
}

export const useBlockLinkCard = ({ block }: BlockLinkCardHookOptions): BlockLinkCardHookReturn => {
  const { buildCtaHref, trackSectionEvent } = useEventsSection({ sectionName: 'discipline-needs' })

  const refHref = computed<string>(() => buildCtaHref(block().url, { text: block().label }))

  const refPlateShape = computed<BrandShapeIconShape>(() => DISCIPLINE_PLATES[block().discipline].shape)
  const refPlateColor = computed<BrandShapeIconColor>(() => DISCIPLINE_PLATES[block().discipline].color)

  const handleClick = (): void => {
    trackSectionEvent('Card_click', { name: 'link_card', text: block().label, url: refHref.value })
  }

  return {
    refHref,
    refPlateShape,
    refPlateColor,
    handleClick,
  }
}
